import CharacterSpine from './CharacterSpine';
import { VehicleVillain } from './VehicleVillain';
import { EquipmentTypeValues, VehicleEquipment } from './VehicleEquipment';
import { LaneEntitySpine } from '../level/entities/LaneEntitySpine';
import { VehicleEquipmentWeapon } from './VehicleEquipmentWeapon';

export abstract class VehicleEquipmentProjectileWeapon extends VehicleEquipmentWeapon {
  protected camera: Phaser.Cameras.Scene2D.Camera;
  protected spine: CharacterSpine;
  protected ammo: typeof LaneEntitySpine;

  constructor(scene: Phaser.Scene, equipmentType: EquipmentTypeValues, vehicle: VehicleVillain, camera: Phaser.Cameras.Scene2D.Camera, spine: CharacterSpine, ammo: typeof LaneEntitySpine) {
    super(scene, equipmentType, vehicle);

    this.camera = camera;
    this.spine = spine;
    this.ammo = ammo;
    this.equipmentType = equipmentType;
  }
}
